<template>
  <v-bottom-sheet v-model="showModal" dark :persistent="true">
    <v-card color="grey darken-4" dark class="pa-4">
      <div id="invite_modal">
        <div class="inviteHeader">
          <div class="inviteTitle">
            {{ $t("hybrid_settings.premium_livestream_invite_title") }}
          </div>
          <div class="inviteSubtitle">
            {{ $t("hybrid_settings.premium_livestream_invite_subtitle") }}
          </div>
        </div>
        <hr class="inviteDivider" />

        <div class="inviteUsersTitle">
          <img src="@/assets/img/hybrid_settings/crown.svg" />
          {{ $t("hybrid_settings.invite_best_gifters") }}
        </div>

        <div class="inviteUsers" @scroll="handleScroll" ref="userList">
          <div
            class="inviteUser"
            v-for="(gifter, index) in pageGifters"
            :key="gifter.user.user_id"
          >
            <div class="placementIcon">
              <img
                v-if="goLiveMode && index == 0"
                src="@/assets/img/hybrid_settings/top-1.svg"
              />
              <img
                v-else-if="goLiveMode && index == 1"
                src="@/assets/img/hybrid_settings/top-2.svg"
              />
              <img
                v-else-if="goLiveMode && index == 2"
                src="@/assets/img/hybrid_settings/top-3.svg"
              />
              <div v-else>{{ index + 1 }}</div>
            </div>
            <div class="userPicture">
              <img
                :src="
                  gifter.user.profile_image
                    ? gifter.user.profile_image.thumbnail_url
                    : emptyProfileURL
                "
              />
            </div>
            <div class="userName">
              {{ gifter.user.name }}
            </div>
            <div class="userCoinIcon">
              <img src="@/assets/img/coin.svg" />
            </div>
            <div class="userCoins">
              {{ showThousund(gifter.coins) }}
            </div>
            <div class="inviteButtonWrapper" @click="toggleSelected(index)">
              <div :class="{ inviteButton: true, selected: gifter.selected }">
                +
              </div>
            </div>
          </div>
          <div class="overscrollPadding" v-if="canLoadMore || loading">
            <span v-if="!loading">···</span>
            <img
              src="@/assets/img/loading.svg"
              alt="loading"
              class="loading"
              v-else
            />
          </div>
        </div>
        <hr class="inviteDivider" />

        <div class="inviteBottomButtonWrapper">
          <div
            class="inviteBottomButton inviteGoLiveButton"
            @click="doneButton()"
            v-if="goLiveMode"
          >
            {{ $t("hybrid_settings.switch_to_premium_button") }}
          </div>
          <div
            class="inviteBottomButton inviteDoneButton"
            @click="doneButton()"
            v-else
          >
            {{ $t("hybrid_settings.done_button") }}
          </div>
        </div>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import _ from "lodash";

import emptyProfileURL from "@/assets/img/empty_profile.png";
import { showThousund } from "@/helper/index.js";

export default {
  name: "InviteModal",
  data() {
    return {
      emptyProfileURL,
      //
      showModal: false,
      pageGifters: [],
    };
  },
  props: ["value", "gifters", "goLiveMode", "canLoadMore", "loading"],
  watch: {
    showModal: function (newVal) {
      this.$emit("input", newVal);
    },
    value: function (newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.userList.scrollTop = 0;
        });
      }
    },
    gifters: function (newVal) {
      this.updateGifters(newVal);
    },
  },
  created() {
    this.updateGifters(this.gifters);
  },
  methods: {
    showThousund,
    updateGifters(gifters) {
      const deepClone = JSON.parse(JSON.stringify(gifters)); // dirty clone
      if (this.value) {
        // If modal is active, keep current selection on pagination.
        const currentSelection = new Set(
          this.pageGifters
            .filter((gifter) => gifter.selected)
            .map((gifter) => gifter.user.user_id)
        );
        deepClone.forEach((item) => {
          item.selected = currentSelection.has(item.user.user_id);
        });
      }
      this.pageGifters = deepClone;
    },
    toggleSelected(index) {
      console.log("toggleSelected", index);
      if (this.pageGifters[index].selected) {
        this.pageGifters[index].selected = false;
      } else {
        this.pageGifters[index].selected = true;
      }
    },
    doneButton() {
      this.$emit(
        "done",
        this.pageGifters
          .filter((gifter) => gifter.selected)
          .map((gifter) => gifter.user.user_id)
      );
    },
    handleScroll(event) {
      if (!this.canLoadMore) return;
      if (this.loading) return;

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // console.log("handleScroll", scrollTop, scrollHeight, clientHeight);

      if (scrollTop + clientHeight >= scrollHeight - 30) {
        this.$emit("loadMore");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#invite_modal {
  background: black;
  color: white;
  font-family: Avenir;
  user-select: none;
}

.inviteHeader {
  padding: 14px 20px 20px;
  text-align: center;
  .inviteTitle {
    font-family: Avenir-Heavy;
    font-size: 16px;
  }
  .inviteSubtitle {
    font-size: 13px;
  }
}

.inviteDivider {
  height: 1px;
  margin: 0;
  background: rgba(157, 157, 157, 0.2);
}

.inviteUsersTitle {
  padding: 12px 22px;
  font-size: 13px;
  font-family: Avenir;
  img {
    width: 19px;
    height: 12px;
  }
}

.inviteUsers {
  min-height: 240px;
  max-height: 360px;
  padding: 0 22px;
  overflow-y: scroll;
  .inviteUser {
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-bottom: 8px;
    .placementIcon {
      width: 20px;
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-content: center;
      div {
        text-align: center;
      }
    }
    .userPicture {
      width: 30px;
      height: 30px;
      border: solid 1px #fff;
      border-radius: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .userName {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
      flex-grow: 1;
      font-size: 14px;
    }
    .userCoinIcon {
      display: flex;
      align-content: center;
      margin-right: -6px;
    }
    .userCoins {
      white-space: nowrap;
      line-height: 30px;
      width: fit-content;
      font-size: 14px;
    }
    .inviteButtonWrapper {
      padding-top: 2px;
    }
    .inviteButton {
      width: 64px;
      height: 24px;
      text-align: center;
      line-height: 20px;
      border-radius: 12px;
      border: solid 1px #fff;
      &.selected {
        background-color: white;
        color: black;
      }
    }
  }
  .overscrollPadding {
    height: 30px;
    text-align: center;
    line-height: 30px;
    overflow: hidden;
    img {
      height: 22px;
    }
  }
}

.inviteBottomButtonWrapper {
  padding: 12px 28px max(30px, env(safe-area-inset-bottom));
  .inviteBottomButton {
    font-family: Avenir-Heavy;
    font-size: 16px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    border-radius: 22px;
    &.inviteGoLiveButton {
      color: black;
      background-image: linear-gradient(
        20deg,
        #805020 -5%,
        #a37e41 7%,
        #c8b064 20%,
        #e3d47e 33%,
        #f3ea8d 45%,
        #f9f293 57%,
        #f4ea8a 69%,
        #e7d472 81%,
        #d2b14a 89%,
        #c3982e 95%
      );
    }
    &.inviteDoneButton {
      color: white;
      background-color: #0095ff;
    }
  }
}
</style>
